import React, { useRef } from "react";
import * as Styles from "./FullscreenCarouselImage.styles";
import ThreeSixtyOverlay from "../ThreeSixtyOverlay";
import { useUscSelector } from "../../../../../redux/store";
import { enable360Spin } from "../../../../../utils/pdpUtils";

type FullscreenCarouselImageType = {
    altTag: string;
    src: string;
    srcSet?: string;
    index: number;
};

const FullscreenCarouselImage = ({ src, altTag, srcSet, index }: FullscreenCarouselImageType): JSX.Element => {
    const result = useUscSelector((state) => state.vehicle.result);
    const aspectRatio = useUscSelector((state) => state.uscSettings.aspectRatio);
    const objectFit = useUscSelector((state) => state.uscSettings.objectFit);

    const has360Spin = enable360Spin(result);
    const wrapperRef = useRef<HTMLDivElement>(null);

    return (
        <Styles.Wrapper id={`slide-fullscreen-${index}`} className="scrollable-element" ref={wrapperRef}>
            <Styles.Image
                src={src}
                srcSet={srcSet}
                alt={altTag}
                objectFit={objectFit}
                data-aspect-ratio={aspectRatio}
            />
            {has360Spin && index === 0 && <ThreeSixtyOverlay />}
        </Styles.Wrapper>
    );
};

export default FullscreenCarouselImage;
